import { CssSpace } from '@xbcb/ui-types';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  display: flex;
  margin-bottom: ${CssSpace.SPACE_4};
`;
